import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Line } from 'vue-chartjs';
import {
  lineChartColors,
  LineChartDatasetInterface, ScoreDailyStatisticInterface,
  TotalDailyStatisticInterface,
} from '@/services/QA/statistics/interfaces';

@Component({})
export default class DailyScoreLineChart extends Mixins(Line) {
  @Prop() public title!: string;
  @Prop() public data!: ScoreDailyStatisticInterface[];
  private dataSets: LineChartDatasetInterface[] = [];
  private color: IterableIterator<string> = lineChartColors[Symbol.iterator]();


  public mounted(): void {
    if (!this.data.length) {
      return;
    }
    this.data.forEach((data) => {
      const index = this.dataSets.findIndex((set) => set.label === data.label);
      if (index === -1) {
        const set: LineChartDatasetInterface = {
          label: data.label,
          data: [data.average],
          tension: 0.1,
          borderColor: this.color.next().value,
          fill: false,
        };
        this.dataSets.push(set);
      } else {
        this.dataSets[index].data.push(data.average);
      }
    });

    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
        labels: this.data.map((d) => new Date(d.date).toLocaleString('en-gb').substr(0, 10))
          .filter((label, index, array) => array.indexOf(label) === index),
        datasets: this.dataSets,
      },
      {
        title: {
          text: this.title,
          display: true,
        },
        onClick: (evt, x: any[]) => {
          if (!x || !x[0]) {
            return;
          }
          const index = x[0]._index;
          const date = this.data[index].date;

          this.$emit('updateTime', date);
        },
        onHover: (event: MouseEvent, chartElement) => {
          if (event.target) {
            // @ts-ignore
            event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
          }
        },
        elements: {
          point: {
            radius: 5,
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Count',
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
                padding: 10,
              },
            },
          ],
        },
      },
    );
  }
}
